/**
 * koala-gift-cart-refresh.js
 * -----------------------------------------------------------------------------
 * Conserta o minicart (cart drawer) do tema Yuva quando o app Koala (Free Gift)
 * adiciona o brinde POR FORA do fluxo do tema.
 *
 * PROBLEMA: a Koala adiciona o brinde chamando POST /cart/add.js via window.fetch,
 * e NAO publica o evento "cartUpdate" do tema. O tema so re-renderiza o drawer
 * quando alguem publica "cartUpdate" (cart-ajax.js:657) ou chama buildCart. Por
 * isso o brinde so aparece quando o cliente fecha e reabre o carrinho (reabrir
 * forca um GET /cart?view=jsonData fresco).
 *
 * SOLUCAO (minima e segura): embrulhamos APENAS window.fetch. O tema usa
 * jQuery/XHR pras acoes nativas (ATC, quantidade, remover, cupom, nota), entao
 * elas NAO sao afetadas. Quando vemos um /cart/add|change|clear via fetch que o
 * tema NAO tratou (ninguem publicou "cartUpdate" depois dele), buscamos /cart.js
 * e re-renderizamos o drawer com window.buildCart.
 *
 * Por que e seguro (revisado contra regressoes):
 *  - So fetch (nao XHR): add nativo do tema usa $.ajax (cart-ajax.js:705) -> ignorado.
 *  - Exclui /cart/update: o save da nota do pedido usa /cart/update.js a cada tecla.
 *  - Dedup: assina "cartUpdate"; se o tema/customizer (garrafa, capa) ja publicou
 *    depois da mutacao, nao faz nada (evita re-render duplo).
 *  - buildCart direto (nao publish): nao re-toca o som/vibracao de "adicionado".
 *  - So age com o drawer ABERTO (drawer fechado ja busca fresco ao abrir; e evita
 *    abrir um pop-up sozinho quando o gatilho do brinde e por valor).
 *  - Sem loop: /cart.js e /cart?view=jsonData nao casam o regex de mutacao.
 * -----------------------------------------------------------------------------
 */
(function () {
  'use strict';

  if (window.__koalaGiftRefreshInstalled) return;
  window.__koalaGiftRefreshInstalled = true;

  // add | change | clear. NAO inclui "update" de proposito (save da nota do pedido).
  var CART_MUTATION_RE = /\/cart\/(add|change|clear)(\.js)?($|\?)/i;
  var DEBOUNCE_MS = 500;

  var timer = null;
  var busy = false;
  var lastCartUpdateAt = 0; // quando o TEMA/customizer ja re-renderizou via pub/sub

  // Dedup: se o tema (ou um customizer de garrafa/capa) publicar "cartUpdate"
  // depois da mutacao, ele ja tratou -> nao re-renderizamos de novo.
  if (typeof subscribe === 'function') {
    try {
      subscribe('cartUpdate', function () { lastCartUpdateAt = Date.now(); });
    } catch (e) { /* silencioso */ }
  }

  function drawerOpen() {
    var c = document.body.classList;
    return c.contains('yv_side_Drawer_open') || c.contains('side_Drawer_open');
  }

  function maybeRefresh(mutatedAt) {
    if (busy) return;
    if (lastCartUpdateAt >= mutatedAt) return; // o tema ja tratou
    if (!drawerOpen()) return;                 // fechado: abre fresco sozinho

    busy = true;
    fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        // re-checa apos o await: o tema pode ter publicado nesse meio tempo
        if (lastCartUpdateAt >= mutatedAt) return;
        if (drawerOpen() && typeof window.buildCart === 'function') {
          // re-renderiza + mantem o drawer aberto, SEM tocar o som (o som esta
          // so no handler de cartUpdate, nao no buildCart).
          window.buildCart(cart, true);
        }
      })
      .catch(function () { /* rede falhou: nao quebra a loja */ })
      .finally(function () { busy = false; });
  }

  var nativeFetch = window.fetch.bind(window);

  window.fetch = function (input, init) {
    var url = '';
    try {
      url = typeof input === 'string' ? input : (input && input.url) || '';
    } catch (e) { url = ''; }

    var p = nativeFetch(input, init);

    if (CART_MUTATION_RE.test(url)) {
      var at = Date.now();
      p.then(function (res) {
        if (res && res.ok) {
          if (timer) clearTimeout(timer);
          timer = setTimeout(function () { timer = null; maybeRefresh(at); }, DEBOUNCE_MS);
        }
      }).catch(function () { /* ignora erro da propria mutacao */ });
    }

    return p;
  };
})();
